<template>
  <router-link to="/restorepassword" tag="div">
    <div class="text-center">
      <i class="far fa-check-circle customCheck"></i>
      <h2 class="p-2 font-weight-bold">¡Se ha enviado el correo correctamente!</h2>
      <p
        class="px-4"
      >Aute officia eiusmod Lorem eiusmod sint duis laborum do non. Fugiat Lorem ad irure enim dolore aute magna qui enim qui do fugiat aute ex. Eiusmod et officia excepteur est.</p>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CorrectPassword'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CorrectPassword.vue?48902c12